(function ($) {
  var $document = $(document);
  $document.ready(function () {
    $('.button-toggle').on('click', function () {
      $('.sponsoring-description').toggle();
      $('.form-sponsoring').toggle();
    });
    /*
    * Player filter
    */
    $document.on('click', '.js-list-filter', function (e) {
      e.preventDefault();
      var $class = $(this).data('id');
      var $parent = $(this).parent('li');
      $parent.addClass('active').siblings().removeClass('active');
      $('.tab-list--content li').each(function () {
        if ($(this).hasClass($class)) {
          $(this).css({
            display: 'block'
          });
        } else {
          $(this).css({
            display: 'none'
          });
        }
      });
    });

    /*
    * Spinner & Nav Menu
    */
    var spinner = document.querySelector('.spinner');
    var spinerMenu = document.querySelector('.header-main > .header-container');
    var topHeader = document.querySelector('.header-top');
    var spinnerClassToggle = function spinnerClassToggle(spinnerClass) {
      var spinnerButton = spinnerClass.querySelectorAll('.spinner-line');
      spinnerClass.classList.toggle('active');
      spinnerButton.forEach(function (elem) {
        elem.classList.toggle('active');
      });
    };
    var level = 0;
    spinner.addEventListener('click', function (event) {
      event.preventDefault();
      topHeader.classList.toggle('active');
      spinerMenu.classList.toggle('active');
      navReset();
      spinnerClassToggle(spinner);
    });
    function navReset() {
      $('.js-open-sub-menu').removeClass('open-menu');
      $('ul.sub-menu').removeClass('active');
      $('ul.sub-menu').removeClass('menu-opacity');
      $('li.menu-item').removeClass('item-opacity');
      $('.menu-item-back-btn').remove();
      level = 0;
    }
    $('.js-open-sub-menu').click(function (e) {
      if (window.innerWidth <= 1024) {
        var target = e.currentTarget;
        if (!target.classList.contains('open-menu')) {
          target.classList.add('open-menu');
          var nextSubMenu = target.nextElementSibling;
          nextSubMenu.classList.add('active');
          if (level === 0) {
            var backButton = "<li class=\"menu-item menu-item-back-btn\"><button class=\"js-back-btn\" type=\"button\">".concat(target.previousElementSibling.textContent, "</button></li>");
            document;
            nextSubMenu.insertAdjacentHTML('afterbegin', backButton);
            $('.js-back-btn').click(function (e) {
              navReset();
            });
            level++;
          } else if (level >= 1) {
            level = 1;
            siblings(target.closest('li.menu-item')).forEach(function (elem) {
              elem.classList.remove('item-opacity');
              elem.lastElementChild.classList.remove('active');
              if (elem.querySelector('.js-open-sub-menu')) {
                elem.querySelector('.js-open-sub-menu').classList.remove('open-menu');
              }
            });
            target.closest('li.menu-item').classList.add('item-opacity');
            target.closest('ul.sub-menu').classList.add('menu-opacity');
          }
        } else {
          target.classList.remove('open-menu');
          var _nextSubMenu = target.nextElementSibling;
          _nextSubMenu.classList.remove('active');
          target.closest('li.menu-item').classList.remove('item-opacity');
          target.closest('ul.sub-menu').classList.remove('menu-opacity');
        }
      }
    });
    function siblings(elem) {
      var siblings = [];
      var sibling = elem;
      while (sibling.previousSibling) {
        sibling = sibling.previousSibling;
        sibling.nodeType == 1 && siblings.push(sibling);
      }
      sibling = elem;
      while (sibling.nextSibling) {
        sibling = sibling.nextSibling;
        sibling.nodeType == 1 && siblings.push(sibling);
      }
      return siblings;
    }
    $('.single-member .header-container .team-item').addClass('current-menu-item');

    /*
    * Spinner Team Tabs
    */
    var spinnerTab = document.querySelector('.spinner--tab');
    var spinnerTubBtn = document.querySelector('.spinner--btn');
    if (spinnerTubBtn) {
      spinnerTubBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.target.closest('.team-groups').querySelector('.tabs-wrapper').classList.toggle('active');
        spinnerClassToggle(spinnerTab);
      });
    }

    /*
    * Team PopUp
    */
    $('.js-popup-close').click(function (e) {
      var target = e.currentTarget.closest('.team_popup');
      console.log(target.closest('.team_popup'));
      $('.team_popup').fadeOut();
    });
    window.addEventListener('resize', function (event) {
      if (window.innerWidth >= 1024) {
        $('.team_popup').fadeIn();
      }
    });

    /*
    * Tooltip sponsoring
    */
    $('.field-sponsoring .is-booked').tooltipster({
      contentAsHTML: true,
      position: 'bottom-left',
      offsetY: -12,
      arrow: false
      //trigger: 'click',
    });
  });
})(jQuery);